import React, { useState, Fragment } from 'react';
import Table from '@nintex-ux/react-core/dist/Table';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@nintex-ux/react-core/dist/Modal';
import { Button } from '@nintex-ux/react-core/dist/Button';
import useFetch from '../../utils/useFetch';

const Registry = ({ isLoading, error, data, getUrl }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scheduleDefinition = useFetch();

  if (isLoading) return 'Loading...';
  if (error) return 'Error fetching registry.';

  const showDefinition = ({ row }) => {
    scheduleDefinition.get(getUrl('definition', { definitionName: row.definitionName }));
    setIsModalOpen(true);
  };

  const processData = data => ({
    ...data,
    state: data.state === 'Enabled' ? 'Yes' : 'No',
    executionStatus: data.executionStatus === 'InProgress' ? 'In Progress' : data.executionStatus,
    definition: {
      component: 'link',
      value: 'Show',
    },
  });

  const renderModalContent = () => {
    const { isLoading, error, response } = scheduleDefinition;

    if (isLoading) return <div className="modal-content-body">Loading...</div>;
    if (error) return <div className="modal-content-body">Error fetching schedule definition.</div>;

    return <pre>{JSON.stringify(response.data, null, 2)}</pre>;
  };

  return (
    <Fragment>
      <Table
        data={[data].map(processData)}
        columns={[
          {
            title: 'Enabled',
            field: 'state',
          },
          {
            title: 'Definition',
            field: 'definition',
          },
          {
            title: 'Execution Status',
            field: 'executionStatus',
          },
          {
            title: 'Version',
            field: 'version',
          },
        ]}
        onRowCommand={showDefinition}
      />

      {isModalOpen && (
        <Modal type="input" open>
          <ModalHeader onClose={() => setIsModalOpen(false)} closeButton>
            Registry Definition
          </ModalHeader>
          <ModalBody>{renderModalContent()}</ModalBody>
          <ModalFooter>
            <Button type="primary" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  );
};

export default Registry;
